var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { addElement } from '@easydata/ui';
import { ChartWidget } from './chart_widget';
import { ChartType } from './chart_type';
var ChartJsWidget = /** @class */ (function (_super) {
    __extends(ChartJsWidget, _super);
    /**
     * The default constructor.
     * @param slot The html element.
     * @param provider The provider.
     */
    function ChartJsWidget(slot) {
        var _this = _super.call(this, slot) || this;
        _this.colors = [
            '#4dc9f6',
            '#f67019',
            '#f53794',
            '#537bc4',
            '#acc236',
            '#166a8f',
            '#00a950',
            '#58595b',
            '#8549ba'
        ];
        _this.chartLabels = [];
        _this.chartColumns = [];
        _this.hasChartTypes = [
            ChartType.Column,
            ChartType.Bar,
            ChartType.Area,
            ChartType.Line,
            ChartType.SteppedLine,
            ChartType.Doughnut,
            ChartType.Polar,
            ChartType.Radar,
            ChartType.Pie
            // ChartType.Bubble,
            // ChartType.Scatter
        ];
        _this.options.legend = {
            show: false,
            position: 'bottom'
        };
        return _this;
    }
    ChartJsWidget.prototype.getWidgetType = function () {
        return 'chartChartJs';
    };
    ChartJsWidget.hasChartJs = function () {
        return typeof Chart !== 'undefined';
    };
    ChartJsWidget.prototype.canDraw = function () {
        return ChartJsWidget.hasChartJs();
    };
    ChartJsWidget.prototype.initChart = function () {
        if (ChartJsWidget.hasChartJs() && this.labelColumn >= 0
            && this.dataColumns && this.dataColumns.length > 0) {
            this.updateChartColumns();
        }
    };
    ChartJsWidget.prototype.drawCore = function () {
        if (ChartJsWidget.hasChartJs() && this.dataTable
            && this.dataTable.getCachedCount() > 0) {
            var config = this.generateConfig();
            var chartCanvas = this.getChartCanvas(this.chartDiv);
            var chartContext = chartCanvas.getContext('2d');
            new Chart(chartContext, config);
        }
    };
    ChartJsWidget.prototype.updateChartColumns = function () {
        if (this.dataTable) {
            this.chartLabels = [];
            this.chartColumns = [];
            var rows = this.dataTable.getCachedRows();
            for (var i = 0; i < rows.length; i++) {
                this.chartLabels.push(rows[i].getValue(this.labelColumn));
                this.chartColumns.push(rows[i].getValue(this.dataColumns[0]));
            }
        }
    };
    ChartJsWidget.prototype.getChartCanvas = function (slot) {
        var result;
        //find canvas element
        var canvases = slot.getElementsByTagName('canvas');
        if (canvases && canvases.length > 0) {
            result = canvases[0];
        }
        else {
            result = addElement(slot, 'canvas');
        }
        return result;
    };
    ChartJsWidget.prototype.generateConfig = function () {
        var dataColors = [];
        var datasetName = this.dataTable.columns.get(this.dataColumns[0]).label;
        var fillValue = true;
        var borderColor;
        if (this.chartType == ChartType.Pie
            || this.chartType == ChartType.Doughnut
            || this.chartType == ChartType.Polar
            || this.chartType == ChartType.Bar
            || this.chartType == ChartType.Column) {
            for (var i = 0; i < this.chartLabels.length; i++) {
                dataColors.push(this.colors[i % this.colors.length]);
            }
        }
        else {
            dataColors = [this.colors[3]];
        }
        if (this.chartType == ChartType.Line
            || this.chartType == ChartType.SteppedLine) {
            fillValue = false;
            borderColor = this.colors[3];
        }
        this.options.legend = this.options.legend || {};
        var dataset1 = {
            data: this.chartColumns,
            backgroundColor: dataColors,
            borderColor: borderColor,
            label: datasetName,
            fill: fillValue
        };
        if (this.chartType == ChartType.SteppedLine) {
            dataset1.stepped = this.chartType === ChartType.SteppedLine, // >= 3.0.0
                dataset1.steppedLine = this.chartType === ChartType.SteppedLine; // <= 3.0.0
        }
        var displayLegend = this.options.legend.show && (this.chartType == ChartType.Pie
            || this.chartType == ChartType.Radar || this.chartType == ChartType.Polar
            || this.chartType == ChartType.Doughnut);
        return {
            type: this.getChartType(),
            data: {
                datasets: [dataset1],
                labels: this.chartLabels
            },
            options: {
                legend: {
                    display: displayLegend,
                    position: this.options.legend.position || 'bottom'
                },
                title: {
                    display: true,
                    text: datasetName
                }
            }
        };
    };
    ChartJsWidget.prototype.getChartType = function () {
        switch (this.chartType) {
            case ChartType.Column:
                return "bar";
            case ChartType.Bar:
                return "horizontalBar";
            case ChartType.Area:
            case ChartType.SteppedLine:
            case ChartType.Line:
                return "line";
            case ChartType.Doughnut:
                return "doughnut";
            case ChartType.Polar:
                return "polarArea";
            case ChartType.Radar:
                return "radar";
            case ChartType.Pie:
                return "pie";
            default:
                return "pie";
        }
    };
    return ChartJsWidget;
}(ChartWidget));
export { ChartJsWidget };
//# sourceMappingURL=chart_widget_chartjs.js.map